import { entity } from 'jsonapi-transformers';

import { HierarchyNode } from './hierarchy-node';

@entity({ type: 'courses' })
export class Course extends HierarchyNode {}
